import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectBundleDO } from '../../../../../../system/system-dtos';

import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';

@Component({
  selector: 'app-form-field-bundle',
  templateUrl: './bundle-form-field.component.html',
  standalone: false,
})
export class BundleFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  selected: SelectBundleDO;

  bundles: SelectBundleDO[] = [];

  bundleData: any;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  bundleId: any;

  hasFormData: boolean = false;

  constructor(
    private blastService: BlastV2Service,
    private entityGroupService: EntityGroupDetailsService
  ) {
    super();
  }

  ngOnInit() {
    this.blastService.getCollectionObservable('bundle').subscribe((list) => {
      this.bundles = list.sort((a: SelectBundleDO, b: SelectBundleDO) => {
        if (a.displayOrder > b.displayOrder) {
          return 1;
        }
        if (a.displayOrder < b.displayOrder) {
          return -1;
        }
        return 0;
      });
      if (this.data !== undefined) {
        this.onBundleChange(
          this.data.bundle ? this.data.bundle : this.data,
          new MatOptionSelectionChange(null, true),
          this.rowData.bundleData ? this.rowData.bundleData : this.rowData.details.bundleData
        );
      }
    });
  }

  onBundleChange(bundle: SelectBundleDO, $event: MatOptionSelectionChange, bundleData) {
    if (!$event.isUserInput || (this.selected && bundle.id === this.selected.id)) {
      return;
    }
    this.selected = bundle;
    this.formGroup.get(this.fieldConfig.name).setValue(this.selected);
    this.bundleId = bundle ? bundle.id : null;

    this.fields = [];
    if (this.selected && this.selected.formConfig) {
      this.selected.formConfig.forEach((row) => {
        if (row.columns !== undefined) {
          row.columns.forEach((column) => {
            if (column.fields !== undefined) {
              column.fields.forEach((f) => {
                this.fields.push(f);
                this.hasFormData = true;
              });
            }
          });
        } else {
          this.hasFormData = false;
        }
      });
    }

    if (bundleData !== undefined && !(Object.keys(bundleData).length === 0 && bundleData.constructor === Object)) {
      this.bundleData = bundleData;
    } else {
      this.bundleData = bundle.dataTemplate;
    }
    this.selectedFieldConfig = { name: 'bundleData', label: 'Product', type: 'criteria' } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;
    this.entityGroupService.isotopeLayout.next();
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}
}
